import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";

const LANGS = [
    { code: "fr", label: "FR" },
    { code: "en", label: "EN" },
];

export default function LanguageSwitcher({ light = false }) {
    const { i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const current = (i18n.language || "fr").startsWith("en") ? "en" : "fr";

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    const change = (code) => {
        i18n.changeLanguage(code);
        setOpen(false);
        // Update URL ?lang= for SEO discoverability
        const url = new URL(window.location.href);
        if (code === "fr") {
            url.searchParams.delete("lang");
        } else {
            url.searchParams.set("lang", code);
        }
        window.history.replaceState({}, "", url.toString());
    };

    const tone = light ? "text-cp-ivoire/80 hover:text-cp-sable" : "text-cp-gris hover:text-cp-foret";

    return (
        <div ref={ref} className="relative" data-testid="language-switcher">
            <button
                type="button"
                onClick={() => setOpen((v) => !v)}
                className={`cp-tiny tracking-[0.2em] ${tone} transition-colors flex items-center gap-1`}
                aria-haspopup="listbox"
                aria-expanded={open}
                data-testid="language-switcher-button"
            >
                {current.toUpperCase()}
                <span className="opacity-50 text-[8px]">▾</span>
            </button>
            {open && (
                <ul
                    role="listbox"
                    className="absolute right-0 top-full mt-2 min-w-[120px] bg-cp-ivoire border border-cp-border shadow-lg py-1 z-[60]"
                    data-testid="language-switcher-menu"
                >
                    {LANGS.map((l) => (
                        <li key={l.code}>
                            <button
                                type="button"
                                onClick={() => change(l.code)}
                                className={`w-full text-left px-4 py-2 text-sm font-light text-cp-encre hover:bg-cp-sable/20 transition-colors ${
                                    current === l.code ? "italic text-cp-foret" : ""
                                }`}
                                data-testid={`language-switcher-${l.code}`}
                            >
                                {l.label === "FR" ? "Français" : "English"}
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
